import { FC, SVGProps } from 'react';

const AddIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = 20,
  color = '#fff',
  height = 24,
  width = 24,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M6 12H18" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12 6V18" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};

export default AddIcon;
